import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { PreviewBody } from "@/components/shapes/shared/card-preview-parts";
import {
  DayAccent,
  EventRows,
} from "@/components/shapes/shared/card-visual-parts";
import { GenericCardPreview } from "@/components/shapes/shared/generic-card-preview";
import { calendarRows, todayAccent } from "./calendar-events";

const MAX_ROWS = 4;

/**
 * The calendar's week (like the agenda card): today in the date accent,
 * then its events with their own colours.
 */
export function CalendarCardPreview(props: CardPreviewProps) {
  const rows = calendarRows(props.source.events).slice(0, MAX_ROWS);
  if (rows.length === 0) return <GenericCardPreview {...props} />;
  return (
    <PreviewBody density={props.density} cap="h-[15em]" className="gap-[0.9em]">
      <DayAccent {...todayAccent()} />
      <EventRows rows={rows} />
    </PreviewBody>
  );
}
